<script>
import {defineComponent} from 'vue'
import {ElNotification} from "element-plus";

export default defineComponent({
  name: "KeyForm",
  data() {
    return {
      loading: false,
      form: {
        id: null,
        board_id: null,
        secret: null
      },
      boards: [],
      rules: {
        board_id: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        secret: [{required: true, message: "Majburiy maydon", trigger: "blur"}]
      }
    }
  },
  methods: {
    getBoards() {
      this.loading = true
      this.$http
          .get(`api/v1/my-school/boards`, {params: {status: 1, offset: 0, limit: 1000}})
          .then(({data}) => {
            this.boards = data.boards;
          })
          .catch((err) => {
            ElNotification.error({
              message:
                  err.response.data.message ||
                  "Doskalar yuklanmadi!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getKeyById() {
      this.loading = true;
      this.$http
          .get(`/api/v1/my-school/secret-keys/${this.form.id}`)
          .then(({data}) => {
            this.form = data;
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;

          let http;
          if (this.form.id) {
            http = this.$http.put(`/api/v1/my-school/secret-keys/${this.form.id}`, this.form);
          } else {
            http = this.$http.post("/api/v1/my-school/secret-keys", this.form);
          }

          http
              .then(() => {
                ElNotification({
                  title: "Tabriklaymiz",
                  message: "Muvafaqiyatli saqlandi",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch(({response}) => {
                ElNotification({
                  title: "Xatolik",
                  message:
                      response.data.message || "Iltimos, qayta urinib ko'ring.",
                  type: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      })
    }
  },
  mounted() {
    this.getBoards()
    if (this.$route.params.id) {
      this.form.id = this.$route.params.id;
      this.getKeyById();
    }
  }
})
</script>

<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
              <el-form-item label="Doskani tanlang" prop="board_id">
                <el-select
                    size="large"
                    v-model="form.board_id"
                    style="width: 100%"
                >
                  <el-option
                      v-for="board in boards"
                      :key="board.id"
                      :value="board.id"
                      :label="board.title +' ' +board.season +'-' +'mavsum ' +board.year +' yil'"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
              <el-form-item label="Kalitni nomi" prop="secret">
                <el-input size="large" type="text" v-model="form.secret"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="() => this.$router.go(-1)"
                >Orqaga
                </el-button
                >
                <el-button class="custom-btn" type="primary" @click="onSubmit"
                >Saqlash
                </el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped lang="scss">
.images {
  columns: 3;

  .image-item {
    position: relative;

    :deep(el-image) {
      border: 1px solid #e4e4e4;
    }
  }
}
</style>
